import { render } from "./ConfigWorkSpaceDetails.vue?vue&type=template&id=475b8167"
import script from "./ConfigWorkSpaceDetails.vue?vue&type=script&lang=js"
export * from "./ConfigWorkSpaceDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__